






































































import { Component } from 'vue-property-decorator';
import IconUser from '@/assets/icons/user.svg';
import colors from 'vuetify/lib/util/colors';
import IdeaIcon from '@/components/Helper/Icon/Svg/IdeaIcon.vue';
import BtnResolveIssueMixin from './btn-resolve-issue.mixin';

@Component<BtnResolveIssue>({
  components: { IdeaIcon },
})
export default class BtnResolveIssue extends BtnResolveIssueMixin {
  colors = colors;

  icons = {
    IconUser,
  };
}
